import {
  BaseLayoutSchema,
  CommonInputWidgetConfigSchema,
} from '@framework/engine';
import { yup } from '@framework/validation';
import {
  IMultiPreferenceWidget,
  WidgetMultiPreferenceType,
} from './IMultiPreferenceWidget';

export const MultiPreferenceWidgetConfigSchema: yup.ObjectSchema<IMultiPreferenceWidget> =
  CommonInputWidgetConfigSchema.shape({
    type: yup.string().exact(WidgetMultiPreferenceType).required(),
    layout: BaseLayoutSchema.shape({}),
    cascade: yup.object({
      fields: yup
        .array(
          yup.object({
            label: yup.string().required(),
            index: yup.number().required(),
          }),
        )
        .default([])
        .label('Colonne'),
      combinations: yup
        .array(
          yup.object({
            values: yup.array(yup.string().required()).required(),
          }),
        )
        .default([])
        .label('Combinazioni Disponibili'),
    }),
  })
    .required()
    .noUnknown();
